import { useEffect, useState } from "react";
import "./ShiHRPage.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { CurriculaService } from "../../../Axios/services/curricula.service";
import CurriculumFolder from "../../content/Curricula/CurriculumFolder/CurriculumFolder";
import CurriculumCI from "../../content/Curricula/CurriculumCI/CurriculumCI";
import Skeleton from "react-loading-skeleton";
import SHIHRCOVER from "../../../assets/images/hr.png";

const ShiHRPage = () => {
  const [t] = useTranslation("common");
  const [curriculum, setCurriculum] = useState<any>([]);
  const [mounted, setMounted] = useState(false);
  const { me } = useSelector((state: any) => state.auth);
  const curriculaService = CurriculaService();
  const [teacherFolders, setTeacherFolders] = useState(true);
  const [learnerFolders, setLearnerFolders] = useState(false);
  const [bothFolders, setBothFolders] = useState(false);

  const getCurriculaById = async () => {
    try {
      const curricula = await curriculaService.getShiHrFolders();
      return curricula.data;
    } catch (err) {
      console.error(err);
    }
  };

  const toggleFolder = (e, folder) => {
    e.preventDefault();
    if (folder === "faculty") {
      setTeacherFolders(true);
      setLearnerFolders(false);
      setBothFolders(false);
    } else if (folder === "staff") {
      setLearnerFolders(true);
      setTeacherFolders(false);
      setBothFolders(false);
    } else if (folder === "both") {
      setLearnerFolders(false);
      setTeacherFolders(false);
      setBothFolders(true);
    }
  };

  useEffect(() => {
    localStorage.setItem("entityLanguage", "Hebrew");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    getCurriculaById()
      .catch((err) => console.error(err))
      .then((res) => {
        setCurriculum(res);
        setMounted(true);
      });
  }, [mounted]);

  const renderSkeleton = () => {
    return (
      <div className="row px-3 px-md-0">
        {Array.from(Array(3).keys()).map((e, i) => {
          return (
            <div className="block-box" key={i}>
              <div className="skeleton-wrapper-bottom">
                <Skeleton className="mark1" height={10} width={150} />
              </div>
              <div className="skeleton-wrapper-top">
                <Skeleton className="mark2" height={30} width={150} />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return curriculum && curriculum.length > 0 && me ? (
    <div className="curriculumPage container-fluid" key={"HRmodule"} dir="rtl">
      <div>
        <div className="d-flex flex-column">
          <div className="curriculumThumbContainer">
            <img alt={"SHIHRCOVER"} src={SHIHRCOVER} className="curriculumThumb" />
          </div>
          <div className="curriculumTitle alignRight">{"משאבי אנוש – מכון הרטמן ישראל"}</div>
          <div className="curriculumDescriptionHR alignRight">
            Hartman connect HR נועד לאפשר גישה נוחה לעובדי ועובדות המכון למידע מתחום משאבי האנוש, רווחה ופרט.
            <br />
            המאגר כולל לוח חופשות, נהלים, טפסים שימושיים, משרות פנויות, ארכיון של הניוזלטר המכוני "זרקור" ועוד.
          </div>
        </div>
        <div className="d-flex flex-column folderOpenedWrapper">
          {curriculum &&
            curriculum.length > 0 &&
            me &&
            curriculum.map(
              (folder: any, index: number) =>
                (folder.permissions[0] === "OpenFaculty" || folder.permissions[0] === "OpenStaff") &&
                folder.status === "Active" && (
                  <div className="fileListWrapper" key={folder._id + "_" + index}>
                    {folder.contentItems.map((item: any) => (
                      <CurriculumCI item={item} mode={"outsideFolder"} />
                    ))}
                  </div>
                )
            )}
        </div>

        <div className="d-flex NavContainerHR">
          <div
            className={`${teacherFolders && !learnerFolders && !bothFolders ? "mr-2 folderFilterBtn ActiveBtn text-right" : "mr-2 folderFilterBtn"} text-right`}
            onClick={(e) => toggleFolder(e, "faculty")}
          >
            חיי קהילת המכון
          </div>
          <div
            className={`${learnerFolders && !teacherFolders && !bothFolders ? "mr-2 folderFilterBtn ActiveBtn" : "mr-2 folderFilterBtn"}`}
            onClick={(e) => toggleFolder(e, "staff")}
          >
            נהלים וטפסים
          </div>
          {/*<div className={`${bothFolders && !teacherFolders && !learnerFolders ? 'mr-2 folderFilterBtn ActiveBtn' : 'mr-2 folderFilterBtn'}`} onClick={(e)=>toggleFolder(e, 'both')}>כולם.ן</div>*/}
        </div>

        {/* {curriculum &&
            curriculum.length > 0 &&
            me &&
            curriculum
              .sort((a, b) => a.title - b.title)
              .map((folder: any) =>
                folder.permissions[0] === "Faculty" && folder.status === "Active" && teacherFolders ? (
                  <CurriculumFolder item={folder} language={"Hebrew"} />
                ) : folder.permissions[0] === "Staff" && folder.status === "Active" && learnerFolders ? (
                  <CurriculumFolder item={folder} language={"Hebrew"} />
                ) : folder.permissions[0] === "All" && folder.status === "Active" && bothFolders ? (
                  <CurriculumFolder item={folder} language={"Hebrew"} />
                ) : null
              )} */}
        {curriculum &&
          me &&
          curriculum.length > 0 &&
          curriculum
            .sort((a, b) => a.title.localeCompare(b.title)) // Use localeCompare for string sorting
            .filter(
              (folder: any) =>
                folder.status === "Active" &&
                ((folder.permissions[0] === "Faculty" && teacherFolders) ||
                  (folder.permissions[0] === "Staff" && learnerFolders) ||
                  (folder.permissions[0] === "All" && bothFolders))
            )
            .map((folder: any, index: number) => (
              <div key={folder.title + "_" + index}>
                <CurriculumFolder item={folder} language={"Hebrew"} />
              </div>
            ))}
      </div>
    </div>
  ) : (
    renderSkeleton()
  );
};

export default ShiHRPage;
